import { useContext, useEffect, useState } from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { Button, Form } from "react-bootstrap";

import RetainerAgreement from "../../Initiate/NewClientPortal/RetainerUploadComponent";
import getArrayBufferFromFile from "../../../../../util/getArrayBufferFromFile";
import PortalService from '../../../services/portal.service';
import StateContext from '../../../context/State';
import { RetainerState } from "../../../types";
import { defaultRetainerState } from "../../../data";
import { FontAwesomeIconNames } from '../../../data'

const UploadRetainerOnDashboardComponent = () => {

    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);
    const sid = useAppSelector((s) => s.SessionInfo.sid);
    const appProvinceShort = useAppSelector((s) => s.SessionInfo.appProvinceShort);

    const [uploadedFile, setUploadedFile] = useState<File>(null);
    const [firmRetainerSourceName, setFirmRetainerSourceName] = useState<string | null>(null);
    //const [currentTextBoxText, setCurrentTextBoxText] = useState<boolean>(false);
    const [currentRetainerExists, setCurrentRetainerExists] = useState<boolean>(false);
    const [retainerState, setRetainerState] = useState<RetainerState>(defaultRetainerState);

    // eslint-disable-next-line
    useEffect(() => { getInitalRetainerState(); }, [])

    const getCurrentRetainer = async (): Promise<void> => {
        try {
            await portalService.getCurrentRetainer(state.portalId);
        } catch (e) {
            console.log('Unable to get Current Retainer: ', e);
        }
    }

    const getInitalRetainerState = async (): Promise<void> => {
        const initRetainerStateResponse = await portalService.getClientPortalRetainerInformation(state.portalId);
        const defaultRetainerRequired = initRetainerStateResponse.DefaultRetainerRequired;
        const textBoxRetainerRequired = initRetainerStateResponse.TextBoxRetainerRequired;
        const uploadRetainer = initRetainerStateResponse.UploadRetainer
        const textBasedRetainer = initRetainerStateResponse.TextBoxRetainerString;
        // logic: if all variations of retainers are not required, retainer is also not required
        const retainerRequired = defaultRetainerRequired || textBoxRetainerRequired || uploadRetainer;
        setRetainerState({
            retainerRequired,
            defaultRetainerRequired,
            textBoxRetainerRequired,
            uploadRetainer,
            textBasedRetainer
        })
        setCurrentRetainerExists(uploadRetainer);
        //setCurrentTextBoxText(textBasedRetainer);
    }

    const setRetainerData = async (portalId: string): Promise<void> => {
        // if retainer is required, make sure other values are set
        if (retainerState.retainerRequired &&
            !retainerState.uploadRetainer &&
            !retainerState.textBoxRetainerRequired &&
            !retainerState.defaultRetainerRequired) {
            // MODAL GOES HERE
            alert('A retainer agreement is set to be required, but is undefined.');
            return;
        }
        // if a text based retainer is required, make sure the value is set
        if (retainerState.textBoxRetainerRequired) {
            if (retainerState.textBasedRetainer === '' || retainerState.textBasedRetainer === null) {
                // MODAL GOES HERE
                alert(' Textbox cannot be empty! ')
                return;
            }
        }

        if (!uploadedFile && retainerState.retainerRequired && !retainerState.uploadRetainer && !retainerState.textBasedRetainer) {
            alert('You must choose a file before submitting!')
            return;
        }

        // if a file was uploaded, make sure its pdf, then upload the file
        if (uploadedFile && retainerState.uploadRetainer && retainerState.retainerRequired) {
            if (uploadedFile.type !== 'application/pdf') {
                // MODAL GOES HERE
                alert('You can only upload Retainers in .pdf format');
                return;
            } else {
                await sendPDF(uploadedFile);
            }
        }
        try {
            await portalService.setRetainerType(retainerState, state.appId, portalId); // API CALL
            // MODAL GOES HERE
            alert('successfully updated retainer')
        } catch (e) {
            // MODAL GOES HERE
            alert(`retainer information was not set: ${e}`)
        }
        getInitalRetainerState();
    }

    const sendPDF = async (file: any): Promise<void> => {
        try {
            const arrayBuffer: any = await getArrayBufferFromFile(file);
            await portalService.uploadDocument(arrayBuffer, state.portalId, state.appId, 'retainer.pdf', 'Retainer');
        } catch (e) {
            // MODAL GOES HERE
            alert(`unable to upload retainer: ${e}`)
        }
    }

    return (
        <>
            {/* <Button onClick={getInitalRetainerState}>
                Refresh
            </Button> */}
            <RetainerAgreement
                setRetainerState={setRetainerState}
                retainerState={retainerState}
                setUploadedFile={setUploadedFile}
                uploadedRetainerFile={uploadedFile}
                firmRetainerSourceName={firmRetainerSourceName}
                setFirmRetainerSourceName={setFirmRetainerSourceName}
                firmRetainerSessionId={sid}
                firmRetainerProvince={appProvinceShort}
            />
            <br />
            <Button variant="primary" onClick={() => setRetainerData(state.portalId.toString())} >
                Submit
            </Button>
            <br /> <br />
            {currentRetainerExists
                ?
                <>
                    <Form.Label>
                        Current Retainer:
                    </Form.Label>
                    <br />
                    <Button
                        variant="link"
                        onClick={() => { getCurrentRetainer() }}
                    >
                        <i className={FontAwesomeIconNames.lightPdf} style={{ padding: 5 }} />
                        retainer.pdf
                    </Button>
                    <br />
                </>
                :
                null
            }
        </>
    )
}

export default UploadRetainerOnDashboardComponent;
